var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisaLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 14,
    viewBox: "0 0 40 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3404 13.1111H14.0765L16.1164 0.230164H19.3806L17.3404 13.1111ZM11.3307 0.230164L8.21898 9.08977L7.85077 7.18195L7.85111 7.18264L6.75285 1.38994C6.75285 1.38994 6.62005 0.230164 5.20456 0.230164H0.0603623L0 0.448269C0 0.448269 1.57311 0.784556 3.41415 1.92056L6.24983 13.1114H9.65057L14.8434 0.230164H11.3307V0.230164ZM37.003 13.1111H40L37.387 0.22982H34.7632C33.5516 0.22982 33.2565 1.18976 33.2565 1.18976L28.3887 13.1111H31.7911L32.4715 11.1978H36.6207L37.003 13.1111ZM33.4115 8.55467L35.1264 3.73431L36.0912 8.55467H33.4115ZM28.6439 3.32773L29.1097 0.561627C29.1097 0.561627 27.6724 0 26.174 0C24.5543 0 20.7079 0.72736 20.7079 4.26424C20.7079 7.59197 25.2223 7.63332 25.2223 9.38126C25.2223 11.1292 21.173 10.816 19.8367 9.71376L19.3514 12.606C19.3514 12.606 20.8089 13.3333 23.0355 13.3333C25.2629 13.3333 28.6231 12.1484 28.6231 8.92334C28.6231 5.57425 24.0681 5.26242 24.0681 3.80632C24.0684 2.34988 27.2472 2.53697 28.6439 3.32773V3.32773Z",
    fill: "#2566AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.85111 7.18197L6.75285 1.38927C6.75285 1.38927 6.62005 0.229492 5.20456 0.229492H0.0603623L0 0.447597C0 0.447597 2.4725 0.97408 4.84406 2.94667C7.11167 4.83209 7.85111 7.18197 7.85111 7.18197Z",
    fill: "#E6A540"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaLogo);
export default __webpack_public_path__ + "static/media/visa-logo.b073970c4fcfcc67c4a70eb3eff73180.svg";
export { ForwardRef as ReactComponent };